import { movies } from "@/mocks/catalog";
import CompactMovie from "@/components/feature/CompactMovie";
import SectionHeading from "@/components/feature/SectionHeading";

const notes = [
  { icon: "ri-map-pin-time-line", text: "常以海边、老街区或书店等固定场景展开，氛围先于情节。" },
  { icon: "ri-chat-quote-line", text: "靠对白与细节推进关系，节奏较慢，适合安静观看。" },
  { icon: "ri-history-line", text: "重逢、错过与等待是高频母题，容易引发共鸣。" },
];

export default function RomanceSection() {
  const items = movies.filter((m) => m.genre === "爱情片");

  return (
    <section id="romance" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-[1.1fr_1fr] lg:gap-14">
          <div className="order-2 flex flex-col gap-4 lg:order-1">
            <p className="text-sm font-medium text-foreground-500">代表作品</p>
            {items.map((movie) => (
              <CompactMovie key={movie.id} movie={movie} />
            ))}
          </div>

          <div className="order-1 flex flex-col gap-6 lg:order-2">
            <SectionHeading
              eyebrow="爱情片专区"
              title="爱情片：把情绪留在细节里"
              description="爱情片的故事往往很小，却足够具体。它关注两个人如何靠近、如何犹豫，也关注时间如何改变一段关系。观看时可以留意场景与道具的变化，它们常常比台词说得更多。"
            />
            <ul className="flex flex-col gap-3">
              {notes.map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-base`}></i>
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700">{item.text}</span>
                </li>
              ))}
            </ul>
            <a
              href="#explorer"
              className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-filter-3-line"></i>
              只筛选爱情片
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}